<template>
  <b-card>
    <h3>Gán nhân viên chăm sóc</h3>
    <b-form @submit.prevent="assignStaff">
      <b-card class="pt-15 b-t-1-869fb229">
        <div class="card-header m-b-10">
          <b-row>
            <b-col md="7">
              <b-row class="box-search">
                <b-form-group label="Vùng kinh doanh">
                  <b-form-select
                    class="form-control f12 hc-37"
                    v-model="selectedRegion"
                    :options="optionRegion"
                  >
                    <template #first>
                      <b-form-select-option :value="null">Tất cả</b-form-select-option>
                    </template>
                  </b-form-select>
                </b-form-group>
                <b-form-group label="Vị trí công việc">
                  <b-form-select
                    class="form-control f12 hc-37"
                    v-model="selectedPosition"
                    :options="optionRole"
                  >
                    <template #first>
                      <b-form-select-option :value="null">Tất cả</b-form-select-option>
                    </template></b-form-select
                  >
                </b-form-group>
                <SearchStaff
                  :selectedRegion="selectedRegion"
                  :selectedPosition="selectedPosition"
                  :excludeIds="excludeIds"
                  @addStaff="addStaff"
                />
              </b-row>
              <b-row>
                <b-col>
                  <div class="list-user">
                    <p v-show="level !== 'STORE'">
                      <b
                        >Tích để chọn 01 nhân viên chính, còn lại là NV phụ, bạn có thể chọn lại vị
                        trí chăm sóc của từng nhân viên.</b
                      >
                    </p>
                    <ul class="list-staff">
                      <li v-for="(staff, index) in selectedEmployees" :key="staff.id">
                        <label class="Checkboxes">
                          <input
                            type="checkbox"
                            v-model="staff.isMain"
                            @change="selectMain(staff)"
                            :disabled="level === 'STORE'"
                          />
                          <span class="checkmark"></span>
                        </label>
                        <div class="user-ID justify-content-space-between">
                          <div class="align-items-center">
                            <img src="@/assets/img/icon-ava.svg" class="avatar ml-1" />
                            <strong class="ml-2">{{ staff.name }}</strong>
                          </div>
                          <div class="align-items-center">
                            <select v-model="staff.types[0]" class="input-no-border">
                              <option
                                v-for="option in optionAsignType"
                                :key="option.value"
                                :value="option.value"
                              >
                                {{ option.text }}
                              </option>
                            </select>
                            <a
                              @click.prevent="removeEmployee(index)"
                              style="cursor: pointer"
                              class="ml-2"
                            >
                              <img src="@/assets/img/icon-close.svg" />
                            </a>
                          </div>
                        </div>
                      </li>
                      <li v-if="selectedEmployees.length === 0">
                        <div class="no-data">Không có dữ liệu, hãy tìm và thêm nhân viên</div>
                      </li>
                    </ul>
                    <b-button
                      variant="primary"
                      @click="assignEmployees"
                      :disabled="!selectedEmployees.length || !tableData.length"
                    >
                      Tạo phiếu gán NVCS
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="5">
              <Guide :level="level" />
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-form>

    <div class="box-header">
      <span
        >Tổng số bản ghi: <strong class="text-primary"> {{ total.toLocaleString('vi-VN') }}</strong>
      </span>
      <span class="mx-2">|</span>
      <input
        v-model="txtSearch"
        type="text"
        class="input-search d-inline-block"
        style="width: 200px; height: 25px; text-indent: 5px"
        placeholder="🔎 Từ khóa"
      />
    </div>
    <Table
      :items="tableDataShow"
      :limit="pagination.limit"
      :page="pagination.page"
      :isShowRemove="false"
      :selectedEmployees="selectedEmployees"
      :level="level"
      :asignType="asignType"
      :isLoading="isLoading"
      @remove="removeAccount"
    />
    <div class="d-flex justify-content-end">
      <b-form-group class="mb-0" style="padding: 17px">
        <b-form-select
          v-model="pagination.limit"
          :options="pageOptions"
          @change="onItemsPerPageChange"
        />
      </b-form-group>
      <b-pagination
        v-model="pagination.page"
        :total-rows="pagination.total"
        :per-page="pagination.limit"
        @change="onChangePage"
      />
    </div>
    <!-- <VueLoadingOverlay :active.sync="isLoading" :is-full-page="true"/> -->

    <PopupSave ref="popupSaveRef" @done="onDone" />
  </b-card>
</template>

<script>
  import { GetIdsByCustomerIds, Search as GetListMa } from '@/services/customer-support/account'
  import { showMess } from '@/config/utils'
  import { GetList as GetListMo } from '@/services/customer-support/merchant-owner'
  import { List as GetListStore } from '@/services/customer-support/store'
  import {
    GetAssignment,
    AssignMO,
    AssignStore,
    AssignOrder,
  } from '@/services/customer-support/store-staff'
  import { CommonService } from '@/services/common.service'
  import { StaffService } from '@/services/staff.service'
  import gzip from 'gzip-js'
  import Table from './components/Table.vue'
  import Guide from './components/Guide.vue'
  import PopupSave from './components/PopupSave.vue'
  import SearchStaff from './components/SearchStaff.vue'
  import { ExecSqlGetOnlyIds } from '@/services/customer-support/filter-services'

  export default {
    props: {
      level: {
        type: String,
        default: null,
      },
    },
    components: {
      Table,
      Guide,
      SearchStaff,
      PopupSave,
    },

    data() {
      return {
        txtSearch: '',
        selectedRegion: null,
        selectedPosition: null,
        mainId: null,
        replaceExisting: false,
        selectedStaff: [],
        optionRegion: [],
        optionRole: [],
        fields: [
          { key: 'index', label: 'STT', thStyle: 'width: 30px', tdClass: 'text-right' },
          { key: 'info', label: 'Thông tin chung', thStyle: 'min-width: 400px' },
          {
            key: 'staff',
            label: 'NV chăm sóc hiện tại',
            thStyle: 'min-width: 200px; max-width: 400px',
          },
          {
            key: 'staffNew',
            label: 'NV chăm sóc đã cập nhật',
            thStyle: 'min-width: 200px; max-width: 400px',
          },
          { key: 'actions', label: 'Hành động', thStyle: 'width: 150px', tdClass: 'text-center' },
        ],
        asignType: {
          CVKD: 'CVKD',
          AS_ONLINE: 'AS Online',
          AS_OFFLINE: 'AS Offline',
          MANAGER_ASSIGNED: 'Cấp quản lý được giao chăm sóc',
          OTHER: 'Khác',
        },
        optionAsignType: [
          { value: 'CVKD', text: 'CVKD' },
          { value: 'AS_ONLINE', text: 'AS Online' },
          { value: 'AS_OFFLINE', text: 'AS Offline' },
          { value: 'MANAGER_ASSIGNED', text: 'Cấp quản lý được giao chăm sóc' },
          { value: 'OTHER', text: 'Khác' },
        ],
        staffId: '',
        loadingStaff: false,
        staffIdOptions: [],
        tableData: [],
        selectedEmployees: [],

        pageOptions: [
          { value: 50, text: '50/trang' },
          { value: 100, text: '100/trang' },
          { value: 200, text: '200/trang' },
        ],

        pagination: {
          page: 1,
          total: 0,
          limit: 50,
        },

        query: '', // get prom optuions
        // excludes: [], // from options
        ids: [],
        deleteds: [], // list id deleted
        isLoading: false,
      }
    },

    computed: {
      tableDataShow() {
        const txt = this.txtSearch.trim().toLocaleLowerCase()
        return txt
          ? this.tableData.filter(
              row =>
                (row.email || '').toLocaleLowerCase().indexOf(txt) >= 0 ||
                (row.accountName || '').toLocaleLowerCase().indexOf(txt) >= 0
            )
          : this.tableData
      },

      total() {
        return this.pagination.total - this.deleteds.length
      },

      excludeIds() {
        return this.selectedEmployees?.reduce((arr, staff) => {
          arr.push(staff.id)
          return arr
        }, [])
      },
    },

    async created() {
      const encodedData = this.$route.query.data
      if (encodedData) {
        const compressed = Uint8Array.from(atob(encodedData), c => c.charCodeAt(0))
        const decompressed = gzip.unzip(compressed)
        const sOptions = String.fromCharCode(...decompressed)
        const optionsObject = JSON.parse(sOptions)
        this.query = optionsObject.query
        // this.excludes = optionsObject.excludes;
      } else {
        showMess(
          this,
          'Thông báo',
          'Không có thông tin đối tượng cần gán',
          'danger',
          'b-toaster-top-right',
          5 * 60 * 60
        )
      }
    },

    async mounted() {
      // if (!this.ids || this.ids.length === 0) return showMess(this, 'Thông báo', 'Không có đối tượng để gán', 'danger', 'b-toaster-top-right', 5 * 60 * 60)
      // await this.loadData();

      // check permission
      if (this.dataPermission.includes('CNPS_CSS_ASSIGN_ORDER_CREATE')) {
        await this.getTypeSale()
        await this.getRegions()
        await this.loadData()
      } else {
        this.$bvModal
          .msgBoxOk('Bạn không có quyền truy cập vào trang này', {
            title: 'Cảnh báo',
            okVariant: 'danger',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true,
          })
          .then(() => {
            this.$router.replace('/')
          })
      }
    },

    methods: {
      onChangePage(pageIndex) {
        this.pagination.page = pageIndex
        this.loadData()
      },

      onItemsPerPageChange() {
        this.pagination.page = 1 // Reset về trang 1 khi thay đổi số mục mỗi trang
        this.loadData()
      },

      async loadData() {
        try {
          this.isLoading = true

          // get ids customer
          const resCustomerIds = await ExecSqlGetOnlyIds({
            page: this.pagination.page,
            limit: this.pagination.limit,
            req: this.query,
          })

          if (resCustomerIds.code !== 1000) {
            return showMess(
              this,
              'Thông báo',
              resCustomerIds.message,
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          }

          const customerIds =
            resCustomerIds.data?.content?.reduce((arr, item) => {
              arr.push(item.merchantIdMyNP)
              return arr
            }, []) || []

          this.pagination.total = resCustomerIds.data?.totalElements || 0

          if (customerIds.length === 0) {
            return showMess(
              this,
              'Thông báo',
              'Không có dữ liệu',
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          }

          const resConvertIds = await GetIdsByCustomerIds(customerIds)

          if (resConvertIds.code !== 1000) {
            return showMess(
              this,
              'Thông báo',
              resConvertIds.message,
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          }

          const maIds = Object.values(resConvertIds.data).filter(id => !this.deleteds.includes(id))

          if (maIds.length === 0) {
            return showMess(
              this,
              'Thông báo',
              'Không có dữ liệu merchant account',
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          }

          // get info assigned
          const res = await GetAssignment({
            assignmentIds: maIds,
            level: this.level,
          })
          const mapStaffAssign = res.data.reduce((map, item) => {
            map[item.assignmentId] = item
            return map
          }, {})

          // get data
          const mapGetList = {
            MERCHANT_OWNER: () => GetListMo({ ids: maIds }),
            MERCHANT_ACCOUNT: () =>
              GetListMa({
                limit: maIds.length,
                page: 1,
                queryString: `{id} IN ['''${maIds.join("''', '''")}''']`,
              }),
            STORE: () =>
              GetListStore({
                limit: maIds.length,
                page: 1,
                showMerchantAccountL: true,
                queryString: `{id} IN ['''${maIds.join("''', '''")}''']`,
              }),
          }

          const listType = mapGetList[this.level]
          if (listType) {
            const resList = await listType()
            const listData = resList.data.listData
            this.tableData =
              listData && listData.length > 0
                ? listData.map(row => {
                    return {
                      ...row,
                      staffMain: mapStaffAssign[row.id]?.staffMain
                        ? {
                            id: mapStaffAssign[row.id].staffMain.staffId,
                            name: mapStaffAssign[row.id].staffMain.staffName,
                            email: mapStaffAssign[row.id].staffMain.staffEmail,
                            types: mapStaffAssign[row.id].staffMain.staffTypes,
                            class: '',
                          }
                        : undefined,
                      staffSecond: mapStaffAssign[row.id]
                        ? mapStaffAssign[row.id].staffSeconds?.map(staff => {
                            return {
                              id: staff.staffId,
                              name: staff.staffName,
                              email: staff.staffEmail,
                              types: staff.staffTypes,
                              class: '',
                            }
                          }) || []
                        : [],
                    }
                  })
                : []
          } else {
            showMess(
              this,
              'Thông báo',
              'Chưa hỗ trợ dạng dữ liệu này',
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          }
        } catch (e) {
          showMess(this, 'Thông báo', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.isLoading = false
        }
      },

      removeAccount(id) {
        this.deleteds.push(id)
        const realIndex = this.tableData.findIndex(row => row.id === id)
        if (realIndex >= 0) this.tableData.splice(realIndex, 1)
      },

      addStaff(user) {
        this.staffId = ''
        // this.showDropdown = false;
        this.selectedEmployees.push({
          id: user.id,
          name: user.name,
          email: user.email,
          types: ['CVKD'],
          isMain: false,
        })
      },

      selectMain(staff) {
        this.selectedEmployees.forEach(otherStaff => {
          if (otherStaff.isMain && otherStaff.id !== staff.id) otherStaff.isMain = false
        })
      },

      removeEmployee(index) {
        this.selectedEmployees.splice(index, 1)
      },

      async assignEmployees() {
        const paramsAssign = {
          levelAssign: this.level,
          assignmentIds: this.tableData.reduce((arr, row) => {
            arr.push(row.id)
            return arr
          }, []),
          infoStaffAssignReqs: this.selectedEmployees?.map(staff => {
            return {
              configType: staff.isMain ? 'MAIN' : 'SECOND',
              staffId: staff.id,
              staffType: staff.types[0],
            }
          }),
        }
        if (this.selectedEmployees.every(staff => !staff.isMain)) {
          paramsAssign.isOnlySecond = true
        }
        this.$refs.popupSaveRef.show(this.query, paramsAssign)
      },

      // async assignEmployees() {
      //   const paramsAssignMA = {
      //     levelAssign: this.level,
      //     assignmentIds: this.tableData.reduce((arr, row) => {
      //       arr.push(row.id)
      //       return arr
      //     }, []),
      //     infoStaffAssignReqs: this.selectedEmployees?.map(staff => {
      //       return {
      //         configType: staff.isMain ? "MAIN" : "SECOND",
      //         staffId: staff.id,
      //         staffType: staff.types[0]
      //       }
      //     })
      //   }
      //   if (this.selectedEmployees.every(staff => !staff.isMain)) {
      //     paramsAssignMA.isOnlySecond = true;
      //   }
      //   const mapAssign = {
      //     MERCHANT_OWNER: () => AssignMO(paramsAssignMA),
      //     MERCHANT_ACCOUNT: () => AssignOrder(paramsAssignMA),
      //     STORE: () => AssignOrder(paramsAssignMA),
      //   };
      //   // const mapRedirect = {
      //   //   MERCHANT_OWNER: '/customer-support/merchant-owner',
      //   //   MERCHANT_ACCOUNT: '/customer-support/account'
      //   // }
      //   try {
      //     this.showLoading = true;
      //     const exeAssign = mapAssign[this.level];
      //     if (exeAssign) {
      //       const res = await exeAssign();
      //       if (res.code == 1000) {
      //         showMess(this, 'Thông báo', res.message, 'success', 'b-toaster-top-right', 5 * 60 * 60);
      //         this.ids = paramsAssignMA.assignmentIds;
      //         this.selectedEmployees.length = 0;
      //         this.loadData();
      //         // localStorage.removeItem(this.$router.currentRoute.params.key);
      //         // this.$router.push(mapRedirect[this.level]);
      //       } else {
      //         showMess(this, 'Thông báo', res.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
      //         if (['MERCHANT_ACCOUNT'].includes(this.level)) {
      //           console.log(res.data)
      //           const errors = res.data
      //           // Update rows with errors and sort them to the top
      //           this.tableData = this.tableData
      //             .map(row => {
      //               if (errors[row.id]) {
      //                 row._rowVariant = 'error';
      //                 row._error = errors[row.id];
      //               }
      //               return row;
      //             })
      //             .sort((a, b) => (a._rowVariant === 'error' ? -1 : 1));
      //         }
      //       }
      //     } else {
      //       showMess(this, 'Thông báo', 'Chưa hỗ trợ lưu dạng dữ liệu này', 'danger', 'b-toaster-top-right', 5 * 60 * 60)
      //     }
      //   } catch (error) {
      //     showMess(this, 'Thông báo', error.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
      //   } finally {
      //     this.showLoading = false;
      //   }
      // },

      async getTypeSale() {
        try {
          const data = await CommonService.getTypeSale({})
          if (data.success) {
            this.optionRole = data.data?.map(e => {
              return {
                value: e.code,
                text: e.name,
              }
            })
          }
        } catch (error) {
          showMess(this, 'Thông báo', error.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        }
      },

      async getRegions() {
        try {
          const data = await StaffService.getRegions()
          if (data.success) {
            this.optionRegion = data.data?.map(e => {
              return {
                value: e.id,
                text: e.name,
              }
            })
          }
        } catch (error) {
          showMess(this, 'Thông báo', error.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        }
      },

      handleBeforeUnload() {
        this.isTabClosing = true
        sessionStorage.setItem('isTabClosing', 'true')
      },

      handleVisibilityChange() {
        if (document.visibilityState === 'visible') {
          this.isTabClosing = false
          sessionStorage.removeItem('isTabClosing')
        } else {
          this.isTabClosing = sessionStorage.getItem('isTabClosing') === 'true'
        }
      },

      handleUnload() {
        if (this.isTabClosing) {
          localStorage.removeItem(this.$router.currentRoute.params.key)
        }
      },

      onDone() {
        this.selectedEmployees.length = 0
        this.pagination.page = 1
        this.loadData()
      },
    },
  }
</script>

<style lang="scss" scoped>
  .staff-list {
    z-index: 1050;
  }

  .note li {
    list-style: disc inside;
  }

  .b-t-1-869fb229 {
    border-top: 1px solid #869fb229 !important;
  }

  .form-group-edid {
    position: relative;
  }

  .form-group-edid input:focus + .add-user {
    display: block;
  }

  .list-user {
    ul {
      margin-bottom: 14px !important;

      li {
        display: flex !important;
        align-items: center !important;
        margin-bottom: 6px !important;
      }
    }
  }

  .user-ID {
    width: 500px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: 10px;
    border: 1px solid #dcdcdc;
    border-radius: 20px;
    padding-right: 10px;
  }

  .user-ID p {
    display: flex;
    align-items: center;
    flex: 1;
  }

  .user-ID p img {
    width: 25px;
    height: 25px;
  }

  .user-ID p select {
    border: 0;
    outline: none;
    box-shadow: none !important;
    margin-left: auto;
  }

  .user-ID li {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .Checkboxes {
    display: block;
    position: relative;
    padding-left: 0px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 25px;
    height: 25px;
  }

  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 7px;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #fff;
    border-radius: 50%;
    border: 2px solid #dcdcdc;
  }

  .Checkboxes input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* On mouse-over, add a grey background color */
  .Checkboxes:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the checkbox is checked, add a blue background */
  .Checkboxes input:checked ~ .checkmark {
    background-color: #fff;
    border-color: #dcdcdc;
  }

  /* Show the checkmark when checked */
  .Checkboxes input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .Checkboxes .checkmark:after {
    left: 3px;
    top: 3px;
    width: 10px;
    height: 10px;
    border: solid #2196f3;
    border-radius: 50%;
    background: #2196f3;
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: '';
    position: absolute;
    display: none;
  }

  .nowrap {
    white-space: nowrap;
  }

  ul.list-staff {
    padding-left: 0;

    li {
      .no-data {
        width: 100%;
        border: 1px dotted #999;
        border-radius: 5px;
        padding: 20px;
        text-align: center;
        color: #999;
      }
    }
  }

  .input-search {
    border-top: none;
    border-left: none;
    border-right: none;
    border-bottom: 1px dotted #999;
    border-radius: 0;
    padding: 0;
    margin: 0;
  }

  .input-no-border {
    border: none;
    outline: none;
    text-align: right;
  }

  .no-data {
    color: #999;
  }

  .box {
    border: 1px solid #ddd;
    border-radius: 5px;
  }

  .d-flex {
    display: flex;
    align-items: center;
  }

  .align-items-center {
    display: flex;
    align-items: center;
  }

  .justify-content-space-between {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .justify-content-start {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .justify-content-end {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  ::v-deep .table-error {
    background-color: rgba(255, 136, 2, 0.1);
  }

  .tooltip-class {
    white-space: pre-line;
    .tooltip-inner {
      background-color: rgb(253, 253, 253);
      color: #319db5;
      text-align: left;
      max-height: 150px;
      max-width: 200px;
      overflow-y: auto;
      border: 1px solid;
    }
  }

  .cursor-pointer {
    cursor: pointer;
  }
</style>
